import React from 'react';
import Layout from '../components/Layout/Layout';
import placementPdf from '../images/Placement cell.pdf';

const PlacementPolicyPage = () => {
  return (
    <Layout>
      <div id="placement-policy" className="page-container" style={{ maxWidth: '800px', fontSize: '0.90rem', margin: '40px auto', padding: '0 20px', minHeight: '300px' }}>
        <h2 style={{ color: 'var(--primary-blue)', borderBottom: '2px solid var(--light-blue)', paddingBottom: '10px', marginBottom: '20px' }}>
          Placement Policy
        </h2>
        <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
          <p style={{ color: '#555', marginBottom: '15px', lineHeight: '1.8' }}>
            Our placement cell provides career guidance and facilitates recruitment opportunities with leading schools and educational institutions.
          </p>
          <iframe src={placementPdf} width="100%" height="800px" title="Placement Policy" style={{ border: 'none', backgroundColor: '#f0f0f0' }} />
        </div>
      </div>
    </Layout>
  );
};

export default PlacementPolicyPage;
